<div class="c-combobox" [class.comp-disabled]="disabled">
    <table [class.comp-disabled]="disabled" class="form-control" style="padding:6px;" [ngClass]="!isForGrid?'':'c-combo-table'"
        (click)="showPopupClick()">
        <tbody style="display:table;width:100%;">
            <tr>
                <td style="width:97%;border-width:0px !important;">
                    <input title={{itemText}} [class.comp-disabled]="disabled" [disabled]="disabled" [ngClass]="cClass" [value]="itemText" [placeholder]="placeHolder"
                        class="c-combo-input" type="text" (keydown)="keypressed($event)" (keyup)="searchData($event)" />
                </td>
                <td class="c-combo-arrow" style="width:20px;">
                    <i class="toggle fas fa-angle-down"></i>
                </td>
            </tr>
        </tbody>
    </table>
    <div [hidden]="!showPopup" class="c-combo-popup" [ngStyle]="{'minWidth':width}">
        <div [ngStyle]="{'height':popUpInnerHeight}">
            <ul class="c-combo-list">
                <li [class.c-combo-item-current]="item.isCurrent" class="c-comobo-item" *ngFor="let item of data" (click)="itemClick(item)">
                    <input type="checkbox" [(ngModel)]="item.checked" *ngIf="checkBoxes" (click)="chkClicked(item,$event)" />
                    <span>{{item[displayMember]}}</span>
                </li>
            </ul>
        </div>
    </div>
</div>